import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import { Modal, Grid, Typography, Container } from "@mui/material";

import arrowImage from "./right-arrow.png";

import * as Yup from "yup";
import { Formik, Form } from "formik";
import TextField from "./Textfield";
import Select from "./Select";
import Button from "./Button";
import { firestore } from "../db/db";
import phCodes from "./countrycodes";

const INITIAL_FORM_STATE = {
  firstName: "",
  lastName: "",
  designation: "",
  brndCompName: "",
  phCode: +92,
  phone: null,
  wPhCode: +92,
  whatsappNum: null,
  email: "",
  compHeadCount: null,
  LinkedInProfUrl: "",
  CompModule: "",
  message: "",
};

const FORM_VALIDATION = Yup.object().shape({
  select: Yup.string(),
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  designation: Yup.string().required("Required"),
  brndCompName: Yup.string(),
  phCode: Yup.mixed(),
  phone: Yup.number()
    .integer()
    .typeError("Please enter a valid phone number")
    .required("Required"),
  wPhCode: Yup.mixed(),
  whatsappNum: Yup.number()
    .integer()
    .typeError("Please enter a valid phone number"),
  email: Yup.string().email("Invalid email.").required("Required"),
  compHeadCount: Yup.number().required("Required"),
  LinkedInProfUrl: Yup.string(),
  CompModule: Yup.string().required("Required"),
  message: Yup.string(),
});

const CustomModal = (props) => {

  let INITIAL_FORM_STATE = {
    meetingDate: props.selectedDate,
    meetingTime: props.selectedTime,
    meetingTimeZone: props.selectedTimezone,
    firstName: "",
    lastName: "",
    designation: "",
    brndCompName: "",
    phCode: +92,
    phone: null,
    wPhCode: +92,
    whatsappNum: null,
    email: "",
    compHeadCount: null,
    LinkedInProfUrl: "",
    CompModule: "",
    message: "",
  };
  const textFieldSyle = {
    borderRaduis: 0,
  };
  const handleSubmit = (values) => {
    console.log(values);
    props.handleCloseModel();
    firestore
      .collection("MeetingData")
      .doc(values.value) // Replace "value" with the appropriate field from your formData object
      .set(values)
      .then(function () {
        console.log("Value successfully written!");
        alert("FORM SAVED IN FIREBASE!");

      })
      .catch(function (error) {
        console.error("Error writing Value: ", error);
      });
  };

    return (
      <section>
        <Modal
          open={props.modalIsOpen}
          onClose={props.handleCloseModel}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          sx={{ overflowY: "auto", hieght: "1200px" }}
        >
          <div style={{ backgroundColor: "whitesmoke" }}>
          <Grid
              container
              spacing={2}
              sx={{
                borderRadius: "50px",
                bgcolor: "white",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                // top: {xs:"90%",sm:"80%", md:"70%", lg:"0%"},
                left: "50%",
                transform: " translate(-50%, 0%)",
                my: 18,
                marginTop: "5rem",
                padding: { xs:"50px 50px",sm:"50px 50px",md:"50px 100px"},
              }}
              style={{
                maxWidth: "950px",
                
              }}
            >
              <Grid xs={12}>
                <div className="x-shape" onClick={props.handleCloseModel}></div>
              </Grid>
              <Grid container textAlign={"center"} direction={"column"}>
                <Typography
                  variant="h6"
                  my={0.5}
                  color="#E00045"
                  fontWeight={"bold"}
                  sx={{ margin: "0" }}
                >
                  SCHEDULE A MEETING
                </Typography>
                <Typography
                  variant="h6"
                  my={0.5}
                  color={"black"}
                  // fontWeight={"bold"}
                  sx={{ margin: "0" }}
                >
                  Please select your preferred meeting DATE & TIME
                </Typography>
                <Typography
                  variant="h6"
                  my={0.5}
                  color={"black"}
                  // fontWeight={"bold"}
                  sx={{ margin: "0" }}
                >
                  KNOWING YOU <span style={{ color: "crimson" }}>BETTER</span>{" "}
                  HELP US
                </Typography>
                <Typography
                  variant="h6"
                  my={0.5}
                  color={"black"}
                  // fontWeight={"bold"}
                  style={{ marginBottom: "20px", marginTop: "0rem" }}
                >
                  SERVES YOU <span style={{ color: "crimson" }}>BETTER</span>
                </Typography>
              </Grid>

              <Container maxWidth="md">
                <Formik
                  initialValues={{
                    ...INITIAL_FORM_STATE,
                  }}
                  validationSchema={FORM_VALIDATION}
                  onSubmit={(values) => {
                    console.log(values);
                    handleSubmit(values);
                  }}
                >
                  {({
                    setFieldValue,
                    setFieldTouched,
                    values,
                    errors,
                    touched,
                  }) => (
                    <Form typeof="submit">
                      <Grid
                        container
                        spacing={3}
                        sx={{ justifyContent: "center" }}
                      >
                        <Grid
                          container
                          item
                          xs={12}
                          sm={12}
                          md={6}
                          direction="row"
                        >
                          <Grid item xs={2} sm={3} md={4}>
                            <Select
                              size="small"
                              name="select"
                              label="Select..."
                              options={["Mr.", "Mrs.", "Ms.", "Miss.", "Dr."]}
                              errors={errors}
                              touched={touched}
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                            />
                          </Grid>
                          <Grid item xs={10} sm={9} md={8}>
                            <TextField
                              size="small"
                              label="First Name*"
                              name="firstName"
                              className={
                                touched.firstName && errors.firstName
                                  ? "error"
                                  : ""
                              }
                              errors={errors}
                              touched={touched}
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                            />
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            size="small"
                            label="Last Name*"
                            name="lastName"
                            errors={errors}
                            touched={touched}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            size="small"
                            label="Designation*"
                            name="designation"
                            errors={errors}
                            touched={touched}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            size="small"
                            label="Brand/Comapny Name"
                            name="brndCompName"
                            errors={errors}
                            touched={touched}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            size="small"
                            label="Website URL"
                            name="websiteURL"
                            errors={errors}
                            touched={touched}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            sm={12}
                            md={6}
                          />
                        </Grid>
                        <Grid
                          container
                          item
                          xs={12}
                          sm={12}
                          md={6}
                          direction="row"
                        >
                          <Grid item xs={4} sm={4} md={3}>
                            <Select
                              size="small"
                              name="phCode"
                              label="+92"
                              options={phCodes}
                              errors={errors}
                              touched={touched}
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                            />
                          </Grid>
                          <Grid item xs={8} sm={8} md={9}>
                            <TextField
                              size="small"
                              label="Phone*"
                              name="phone"
                              errors={errors}
                              touched={touched}
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          item
                          xs={12}
                          sm={12}
                          md={6}
                          direction="row"
                        >
                          <Grid item xs={4} sm={3} md={3}>
                            <Select
                              size="small"
                              name="wPhCode"
                              label="+92"
                              options={phCodes}
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                            />
                          </Grid>
                          <Grid item xs={8} sm={9} md={9}>
                            <TextField
                              size="small"
                              label="WhatsApp"
                              name="whatsappNum"
                              errors={errors}
                              touched={touched}
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                            />
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            size="small"
                            label="Email*"
                            name="email"
                            errors={errors}
                            touched={touched}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <Select
                            size="small"
                            name="compHeadCount"
                            label="Company Head Count*"
                            options={[
                              "1-10",
                              "11-50",
                              "51-200",
                              "201-500",
                              "501-1000",
                              "1001-5000",
                              "5001-10,000",
                              "10,000+",
                              "Self-employed",
                            ]}
                            errors={errors}
                            touched={touched}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            size="small"
                            label="LinkedIn Profile URL"
                            name="LinkedInProfUrl"
                            errors={errors}
                            touched={touched}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="p" fontWeight={"bold"}>
                            Which Business Module Do You Operate In?*
                          </Typography>
                          <Select
                            size="small"
                            name="CompModule"
                            label="Select"
                            options={["B2B", "B2C", "Both", "For Clients"]}
                            errors={errors}
                            touched={touched}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            size="small"
                            name="message"
                            label="Please share anything that will help prepare for our meeting."
                            options={["xyz"]}
                            multiline={true}
                            rows={4}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                          />
                        </Grid>
                        <Grid item xs={8} sm={8} md={4}>
                          {/* <Button style={{ background: "linear-gradient(-40deg, #3e037e 0%, #f27c9d 51%, #3e037e 100%)" }}>Submit Form</Button> */}
                          <Button
                            onClick={props.handleCloseModel}
                            variant="outlined"
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <span style={{ marginRight: "40px" }} >
                              Submit Form
                            </span>
                            <img src={arrowImage} alt="Arrow" width="20px" />
                          </Button>
                        </Grid>
                        <Grid item xs={12} padding={0}>
                          <Typography
                            variant="body2"
                            fontWeight={"bold"}
                            spacing={0}
                          >
                            By choosing to "Schedule Meeting" you are agreeing
                            to our Privacy Policy, which describes how we
                            process your information. you consent for Moris
                            Digital and its partners to use automated
                            technology, including pre-recorded messages, cell
                            phones, texts, and emails to contact you at the
                            number and email address provided. This includes if
                            the number is currently on any Do Not Call Lists.
                            This consent is not required to make a purchase.{" "}
                            <Link style={{ color: "#E00045" }} to="#">
                              Privacy Policy.
                            </Link>
                          </Typography>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </Container>
            </Grid>
          </div>
        </Modal>


      </section>
    );
}

export default CustomModal;
